import { IAdSectionBid } from 'types/adManagement';
import { IBaseTableData } from 'components/Table';

export enum EAdBidListStatusActions {
	RESUME = 'resume',
	PAUSE = 'pause',
	CANCEL = 'cancel',
}

export interface IAdBidListTableData extends IAdSectionBid, IBaseTableData {}
